import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { columnTypes } from "src/components/UI/atoms/ATMTable/ATMTable";
import { DigitalPANListResponse } from "src/models/DigitalPAN.model";
import {
  setIsTableLoading,
  setItems,
  setTotalItems,
} from "src/redux/slices/DigitalPANSlice";
import { AppDispatch, RootState } from "src/redux/store";
import { useCheckPanStatusMutation, useCheckTransactionStatusMutation, useGetDigitalPanPendingApplicationsQuery } from "src/services/DigitalPanService";
import { formatDateAndTime } from "src/utils/dateAndTime";
import { getColumns } from "src/utils/auth/getColumns";
import DigitalPanGenerateListing from "./DigitalPanListing";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { applicationStatus } from "src/pages/history/list/Dialog/HistoryDialog";
import { showToast } from "src/utils/toaster/showToast";
import ViewDownloadDialog from "../Dialog/ViewDownloadDialog";

const paramList = [
  "_id",
  "txnId",
  "mobileNumber",
  "applicationStatus",
  "status",
  "transactions",
  "agentID",
  "createdAt",
  "updatedAt"
];

const DigitalPanListingWrapper = () => {
  // Dispatch Hook
  const dispatch = useDispatch<AppDispatch>();
  // Slice
  const DigitalPanApplicationState: any = useSelector(
    (state: RootState) => state?.DigitalPANSlice
  );

  const [checkTransactionStatus, { isLoading: txnLoading }] = useCheckTransactionStatusMutation();
  const [checkPanStatus, { isLoading: panLoading }] = useCheckPanStatusMutation();
  const [statusDialogOpen, setStatusDialogOpen] = useState(false);
  const [statusDialogTitle, setStatusDialogTitle] = useState("");
  const [statusDialogContent, setStatusDialogContent] = useState<any>(null);

  const { items, searchValue, rowsPerPage, page, filterBy, dateFilter } =
    DigitalPanApplicationState;

  // Get Data Query
  const { data, isFetching, isLoading } = useGetDigitalPanPendingApplicationsQuery({
    limit: rowsPerPage,
    searchValue: searchValue,
    params: paramList,
    page: page,
    filterBy: filterBy,
    dateFilter: dateFilter,
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: true,
  });

  // Setting data
  React.useEffect(() => {
    if (!isFetching && !isLoading) {
      dispatch(setIsTableLoading(false));
      dispatch(setItems(data?.data || []));
      dispatch(setTotalItems(data?.totalItem || 0));
    } else {
      dispatch(setIsTableLoading(true));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isFetching, data]);

  const columns: columnTypes[] = [
    {
      field: "createdAt",
      headerName: "Date - Time",
      flex: "flex-[1_1_0%]",
      noAuthRequired:true ,
      renderCell: (row: DigitalPANListResponse) => (
        <div>
          <div className="text-slate-700 font-medium">
            {formatDateAndTime(row.createdAt, "DD MMM yyyy")}
          </div>
          <div className="text-[13px] font-medium text-slate-400">
            {formatDateAndTime(row.createdAt, "hh:mm A")}
          </div>
        </div>
      ),
    },
    // {
    //   field: "txnId",
    //   headerName: "Txn Id",
    //   flex: "flex-[1_1_0%]",
    // },
  
    {field: "Transactions",
      headerName: "Acknowledgment No.",
      flex: "flex-[1_1_0%]",
      renderCell: (row: DigitalPANListResponse) => (
        <span className={`overflow-hidden  `}>{row?.Transactions?.AckNo?row?.Transactions?.AckNo:'-'} </span>
      ),
      },
     {
        field: "applicantName",
        headerName: "Applicant Name",
        flex: "flex-[1_1_0%]",
      },
      {
        field: "mobileNumber",
        headerName: "Applicant Mobile",
        flex: "flex-[1_1_0%]",
      },
      {
        noAuthRequired: true,
        field: "distributorCode",
        headerName: "SJBT  Code",
        flex: "flex-[1.2_1.2_0%]",
        renderCell: (row: DigitalPANListResponse) => {
          return <span> {row.distributorCode || "N/A"} </span>;
        },
      },
      {
        field: "appliedByNumber",
        headerName: "Applied By (Mob. No.)",
        flex: "flex-[1_1_0%]",
        renderCell: (row: DigitalPANListResponse) => {
          return <span> {row.appliedByNumber || "N/A"} </span>;
        },
      },
      {field: "appliedByName",
        headerName: "Applied By Name",
        flex: "flex-[1_1_0%]",
        renderCell: (row: DigitalPANListResponse) => (
          <span className={`text-ellipsis overflow-hidden  font-semibold`}>{row?.appliedByName} </span>
        ),
      },
      {
        field: "totalPrice",
        headerName: "Total Price",
        flex: "flex-[1_1_0%]",
        renderCell: (row: DigitalPANListResponse) => (
          <span className={`text-ellipsis overflow-hidden  font-semibold`}>{row?.totalPrice} </span>
        ),
      },
      {field: "Type",
      headerName: "Application Type",
      flex: "flex-[1_1_0%]",
      renderCell: (row: DigitalPANListResponse) => (
        <span className={`overflow-hidden  `}>{row?.Type  ==='N' ? 'New Pan' :row?.Type == null?'Failed': 'Correction Pan'    } </span>
      ),
    },
      {
      field: "status",
      headerName: "Status",
      flex: "flex-[1_1_0%]",
      renderCell: (row: DigitalPANListResponse) => (
        <span className={`text-ellipsis overflow-hidden ${applicationStatus(row)?.className} font-semibold`}> {applicationStatus(row)?.label} </span>
      ),
    },
  
// {
//   noAuthRequired: true,
//   field: "action",
//   headerName: "Action",
//   flex: "flex-[0_0_220px]", // ⬅️ increased width
//   renderCell: (row: any) => {

//     // const handleGenerate = () => {
//     //   setRowData(row);
//     //   setIsOpenDownloadDialog(true);
//     // };

//     // const handleDownload = () => {
//     //   if (row?.employercertificatesData?.file) {
//     //     downloadPdfFile(row.employercertificatesData.file);
//     //   } else {
//     //     console.error("File URL is missing.");
//     //   }
//     // };

//     const handleTransactionStatus = async () => {
//       try {
//         const res = await checkTransactionStatus({
//           pancardRefId: row.txnId,
//         }).unwrap();

//         setStatusDialogTitle("Transaction Status");
//         setStatusDialogContent(res?.data);
//         setStatusDialogOpen(true);
//       } catch (err: any) {
//         showToast("error", err?.data?.message || "Failed to fetch transaction status");
//       }
//     };

//     const handlePanStatus = async () => {
//       try {
//         const res = await checkPanStatus({
//           pancardRefId: row.txnId,
//         }).unwrap();

//         setStatusDialogTitle("PAN Status");
//         setStatusDialogContent(res?.data);
//         setStatusDialogOpen(true);
//       } catch (err: any) {
//         showToast("error", err?.data?.message || "Failed to fetch PAN status");
//       }
//     };

//     return (
//       <div className="flex flex-wrap gap-2 items-center">

//         {/* 🔵 Transaction Status */}
//         <button
//           className="py-1 px-2 rounded text-xs bg-blue-500 text-white hover:bg-blue-600"
//           onClick={handleTransactionStatus}
//         >
//           Txn Status
//         </button>

//         {/* 🟣 PAN Status */}
//         <button
//           className="py-1 px-2 rounded text-xs bg-purple-500 text-white hover:bg-purple-600"
//           onClick={handlePanStatus}
//         >
//           PAN Status
//         </button>

//       </div>
//     );
//   },
// }
{
  noAuthRequired: true,
  field: "action",
  headerName: "Action",
  flex: "flex-[0_0_220px]",
  renderCell: (row: any) => {

    // 👉 Only show if status is pending
    if (row?.status !== "PENDING") return null;

    const handleTransactionStatus = async () => {
      try {
        const res = await checkTransactionStatus({
          pancardRefId: row.txnId,
        }).unwrap();

        setStatusDialogTitle("Transaction Status");
        setStatusDialogContent(res?.data);
        setStatusDialogOpen(true);
      } catch (err: any) {
        showToast("error", err?.data?.message || "Failed to fetch transaction status");
      }
    };

    const handlePanStatus = async () => {
      try {
        const res = await checkPanStatus({
          pancardRefId: row.txnId,
        }).unwrap();

        setStatusDialogTitle("PAN Status");
        setStatusDialogContent(res?.data);
        setStatusDialogOpen(true);
      } catch (err: any) {
        showToast("error", err?.data?.message || "Failed to fetch PAN status");
      }
    };

    return (
      <div className="flex flex-wrap gap-2 items-center">
        <button
          className="py-1 px-2 rounded text-xs bg-blue-500 text-white hover:bg-blue-600"
          onClick={handleTransactionStatus}
        >
          Txn Status
        </button>

        <button
          className="py-1 px-2 rounded text-xs bg-purple-500 text-white hover:bg-purple-600"
          onClick={handlePanStatus}
        >
          PAN Status
        </button>
      </div>
    );
  },
}

  ];

  return (
    <>
    <SideNavLayout>
    <DigitalPanGenerateListing
        columns={getColumns(columns, "DIGITAL_PAN_APPLICATIONS")}
        rows={items}
      />
    {statusDialogOpen && (
          <ViewDownloadDialog
            onClose={() => setStatusDialogOpen(false)}
            data={statusDialogContent}
            title={statusDialogTitle}
          />
        )}
    </SideNavLayout>
    </>
  );
};

export default DigitalPanListingWrapper;

